import { I18nApiService, setLangJSON } from '@zenlayer/zen-intl18';
import { useRequest } from 'ahooks';
import { useState } from 'react';

const setLangByEnv = async () => {
  try {
    const { getI18nStrings } = new I18nApiService({
      env: getRuntimeInfo().env,
      isProduction: __PRODUCTION__,
      projectId: __I18N_CONFIG__.id,
      gitBranch: __GIT_BRANCH__,
    });

    const i18nStrings = await getI18nStrings();
    setLangJSON({ text: i18nStrings });
  } catch (e) {
    setLangJSON({ text: {} });
    console.error(e);
  }
};

export const getRuntimeInfo = () => {
  if (!window._zen_env_) {
    console.warn('window._zen_env_ is undefined, use default');
    window._zen_env_ = {
      env: 'ci',
      online: false,
      public_path: '/',
      console_href: 'https://portal-dev.hzk8s.com',
    };
  }

  return window._zen_env_;
};

export default function useRuntimeInfo() {
  const [ready, setReady] = useState(false);
  const zenEnv = getRuntimeInfo();

  useRequest(async () => {
    let env;

    if (__PRODUCTION__) {
      env = zenEnv.online ? 'ONLINE' : 'TEST';
    } else {
      env = 'DEVELOPMENT';
    }

    await setLangByEnv();
    setReady(true);
  });

  return {
    ready,
  };
}
